import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Banner } from "../../Domain/Model/Banner";
import { Banners } from "../../Domain/Model/Banners";
import { BannerState } from "../../Domain/Model/BannerState";
import { Modal } from "../../Domain/Model/Modal/Modal";
import { Modals } from "../../Domain/Model/Modal/Modals";
import { OfferUpdateImageAndTiner, OfferUpdateSlider, UpdateOffer } from "../../Domain/Model/Offer";
import { OfferItemSlider } from "../../Domain/Model/OfferItemSlider";
import { Offers } from "../../Domain/Model/Offers";
import { OfferState } from "../../Domain/Model/OfferState";
import { Products } from "../../Domain/Model/Products";
import { OffersPromoRepository } from "../../Domain/Repository/OffersPromoRepository";

import OffersPromoDataSource from "../DataSource/OffersPromoDataSource";

export class OffersPromoRepositoryImpl implements OffersPromoRepository {
  dataSource: OffersPromoDataSource;

  constructor(_datasource: OffersPromoDataSource) {
    this.dataSource = _datasource;
  }
  updateBannerList(bannerId: number, data: FormData): Promise<boolean> {
    return this.dataSource.updateBannerList(bannerId, data);
  }
  updateBannerSingle(bannerId: number, data: FormData): Promise<boolean> {
    return this.dataSource.updateBannerSingle(bannerId, data);
  }
  getBanners(page: number, pageSize: number, search: string): Promise<PaginationResult<Banners>> {
    return this.dataSource.getBanners(page, pageSize, search);
  }
  getBannerById(id: number): Promise<Banner | null> {
    return this.dataSource.getBannerById(id);
  }
  createBanner(data: Banner): Promise<boolean> {
    return this.dataSource.createBanner(data);
  }
  updateStateBanner(data: BannerState): Promise<boolean> {
    return this.dataSource.updateStateBanner(data);
  }
  updateTableBanner(data: Banner): Promise<boolean> {
    return this.dataSource.updateTableBanner(data);
  }
  removeBannerItemTable(bannerId: number): Promise<boolean> {
    return this.dataSource.removeBannerItemTable(bannerId);
  }

  getProducts(page: number, pageSize: number, search: string): Promise<PaginationResult<Products>> {
    return this.dataSource.getProducts(page, pageSize, search);
  }

  getOffers(page: number, pageSize: number, search: string, typeOfferImage: number): Promise<PaginationResult<Offers>> {
     return this.dataSource.getOffers(page, pageSize, search, typeOfferImage);
  }
  createOffer(data: any): Promise<boolean> {
     return this.dataSource.createOffer(data);
  }
  updateStateOffer(data: OfferState): Promise<boolean> {
    return this.dataSource.updateStateOffer(data);
  }
  updateTableOffer(data: Offers): Promise<boolean> {
    return this.dataSource.updateTableOffer(data);
  }
  updateSliderOffer(itemId: number, data: FormData): Promise<boolean> {
    return this.dataSource.updateSliderOffer(itemId, data);
  }
  getOfferImagesById(id: number): Promise<OfferUpdateImageAndTiner | null> {
    return this.dataSource.getOfferImagesById(id);
  }
  getOfferSliderById(id: number): Promise<OfferUpdateSlider | null> {
    return this.dataSource.getOfferSliderById(id);
  }
  getOfferTimerById(id: number): Promise<OfferUpdateImageAndTiner | null> {
    return this.dataSource.getOfferTimerById(id);
  }
  removeOfferRow(offerId: number, rowId: string): Promise<boolean> {
    return this.dataSource.removeOfferRow(offerId, rowId);
  }
  removeOfferItem(rowId: string, itemId: number): Promise<boolean> {
    return this.dataSource.removeOfferItem(rowId, itemId);
  }
  updateItemOffer(itemId: number, Image: FormData): Promise<boolean> {
    return this.dataSource.updateItemOffer(itemId, Image);
  }
  updateOfferImages(offerId: number, data: UpdateOffer): Promise<boolean> {
    return this.dataSource.updateOfferImages(offerId, data);
  }
  updateOfferList(itemId: number, data: any): Promise<boolean> {
    return this.dataSource.updateOfferList(itemId, data);
  }
  updateOfferSingle(itemId: number, data: any): Promise<boolean> {
    return this.dataSource.updateOfferSingle(itemId, data);
  }
  getOfferItemSliderById(itemId: number): Promise<OfferItemSlider | null> {
    return this.dataSource.getOfferItemSliderById(itemId);
  }
  updateDarkMode(itemId: number, data: any): Promise<boolean> {
    return this.dataSource.updateDarkMode(itemId, data);
  }
  updateTimer(itemId: number, data: any): Promise<boolean> {
    return this.dataSource.updateTimer(itemId, data);
  }
  removeOfferItemTable(offerId: number): Promise<boolean> {
    return this.dataSource.removeOfferItemTable(offerId);
  }


  getModals(page: number, pageSize: number, search: string): Promise<PaginationResult<Modals>> {
    return this.dataSource.getModals(page, pageSize, search);
  }
  getModalById(id: number): Promise<Modal | null> {
    return this.dataSource.getModalById(id);
  }
  createModal(data: Modal): Promise<boolean> {
    return this.dataSource.createModal(data);
  }
  updateStateModal(modalId: number): Promise<boolean> {
    return this.dataSource.updateStateModal(modalId);
  }
  updateModalList(modalId: number, data: FormData): Promise<boolean> {
    return this.dataSource.updateModalList(modalId, data);
  }
  updateModalSingle(modalId: number, data: FormData): Promise<boolean> {
    return this.dataSource.updateModalSingle(modalId, data);
  }
  removeModalItemTable(modalId: number): Promise<boolean> {
    return this.dataSource.removeModalItemTable(modalId);
  }
}